import request from '@/utils/request'

export function recordList(opType, data) {
  return request({
    url: 'api/data/' + opType,
    method: 'post',
    params: data
  })
}

export function fetchFuel(data) {
  return request({
    url: 'api/data/fuel',
    method: 'post',
    params: data
  })
}

export function fetchAmtHistory(data) {
  return request({
    url: 'api/member/amount',
    method: 'post',
    params: data
  })
}

export function fetchPointHistory(data) {
  return request({
    url: 'api/member/point',
    method: 'post',
    params: data
  })
}

export function fetchFuelHistory(data) {
  return request({
    url: 'api/data/fuel',
    method: 'post',
    params: data
  })
}

export function fetchAnalysis(data) {
  return request({
    url: 'api/data/fetchAnalysis',
    method: 'post',
    data: data
  })
}

export function fetchTotalRefund(data) {
  return request({
    url: 'api/data/fetchTotalRefund',
    method: 'post',
    data: data
  })
}

export function fetchTotalCharge(data) {
  return request({
    url: 'api/data/fetchTotalCharge',
    method: 'post',
    data: data
  })
}

export function fetchTotalFuel(data) {
  return request({
    url: 'api/data/fetchTotalFuel',
    method: 'post',
    data: data
  })
}

export function shiftCardFuel(data) {
  return request({
    url: 'api/data/shiftCardFuel',
    method: 'post',
    data: data
  })
}

export function shiftFpOrder(data) {
  return request({
    url: 'api/data/shiftFpOrder',
    method: 'post',
    data: data
  })
}

export function shiftRechargePaid(data) {
  return request({
    url: 'api/data/shiftRechargePaid',
    method: 'post',
    data: data
  })
}

export function shiftUserPaid(data) {
  return request({
    url: 'api/data/shiftUserPaid',
    method: 'post',
    data: data
  })
}

export function fetchShiftRecord(data) {
  return request({
    url: 'api/data/fetchShiftRecord',
    method: 'post',
    data: data
  })
}

export function fetchRechargeAnal(data) {
  return request({
    url: 'api/data/fetchRechargeAnal',
    method: 'post',
    data: data
  })
}

export function dailyFuelOrder(data) {
  return request({
    url: 'api/data/dailyFuelOrder',
    method: 'post',
    data: data
  })
}

//��ȡ��ǰ�����Ϣ
export function getCurrentClassesApi(data) {
  return request({
    url: 'api/shift/getCurrentClasses',
    method: 'get',
    data: data
  })
}

//����ӿ�
export function handoverApi(data) {
  return request({
    url: 'api/shift/handover',
    method: 'post',
    data: data
  })
}
